export const STUDIO_KEY_LIGHT_POSITION:[number, number, number] = [-4, 6, 5];
export const STUDIO_REFLECTION_CAPTURE_ACTIVE_USER_DATA_KEY = (
    'modelViewerStudioReflectionCaptureActive'
);
export const STUDIO_TRANSMISSION_CAPTURE_ACTIVE_USER_DATA_KEY = (
    'modelViewerStudioTransmissionCaptureActive'
);
